export enum EHeaderType {
  HOME = 'home',
  DEFAULT = 'default',
  SEARCH = 'search',
  USER = 'user',
  FEED = 'feed',
}
